import React from 'react';
import { Dialog } from '@mui/material';
import AddStakeHolder from './AddStakeHolder';
import EditStakeHolder from './EditStakeHolder';

const ToggleModal = ({
  open,
  toggle,
  isEdit,
  getData,
  data,
  length,
  segments,
  setSnackBarOpen,
  setSnackbarSeverity,
  setSnackBarMessage,
}) => {
  return (
    <Dialog
      open={open}
      keepMounted
      maxWidth="md"
      fullWidth
      scroll="paper"
      onClose={toggle}
    >
      {!isEdit && (
        <AddStakeHolder
          toggle={toggle}
          open={open}
          getData={getData}
          length={length}
          segments={segments}
          setSnackBarOpen={setSnackBarOpen}
          setSnackbarSeverity={setSnackbarSeverity}
          setSnackBarMessage={setSnackBarMessage}
        />
      )}
      {isEdit && (
        <EditStakeHolder
          toggle={toggle}
          open={open}
          data={data}
          getData={getData}
          segments={segments}
          setSnackBarOpen={setSnackBarOpen}
          setSnackbarSeverity={setSnackbarSeverity}
          setSnackBarMessage={setSnackBarMessage}
        />
      )}
    </Dialog>
  );
};

export default ToggleModal;
